import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { ISearchListProps } from './interface';

export const SearchListComponent = ({
  comparisonMode,
  hiddenExtras,
  onSelectAsset,
  assets = [],
}: ISearchListProps) => {
  return (
    <MenuList
      sx={{
        '& .MuiMenuItem-root': {
          whiteSpace: 'normal',
        },
      }}
    >
      {assets.map((asset) => {
        return (
          <MenuItem
            id="result-item"
            key={asset.identifier}
            // LinkComponent={
            //   (comparisonMode ? NextLink : undefined) as any
            // }
            // href={
            //   comparisonMode ? asset.canonical_url : undefined
            // }
            divider
            disabled={asset.isDisabled(comparisonMode)}
            onClick={comparisonMode ? () => onSelectAsset(asset) : undefined}
            sx={{
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Typography fontWeight={500} flexWrap="wrap" gutterBottom>
              {asset.nicename}
            </Typography>

            {!hiddenExtras ? (
              <Stack flexDirection="row" flexWrap="wrap" gap={1}>
                <Typography
                  sx={{
                    borderRadius: 1,
                    backgroundColor: '#e7e7e7',
                    py: '2px',
                    px: 2,
                    fontSize: '0.7rem',
                  }}
                >
                  {asset.type}
                </Typography>

                {asset?.info?.map((info) => (
                  <Typography sx={{ fontSize: '0.8rem' }} key={info.slug}>
                    {info.displayName}:
                    <span style={{ fontWeight: 600 }}> {info.value}</span>
                  </Typography>
                ))}
              </Stack>
            ) : null}
          </MenuItem>
        );
      })}
    </MenuList>
  );
};
